import { useCallback } from 'react';
import gql from 'graphql-tag';
import {
  useConversationNav_Rh_GetConversationByIdQuery,
  useConversationNav_Rh_UpdateConversationStatusMutation,
  useInboxPage_Rh_UpdateConversationStatusMutation,
  useRh_GetSyndicationUrlsQuery,
  useRh_RequestToApplyMutation,
} from '../types/GraphqlTypes';
import brandUtils from '../utils/brandUtils';

export default () => {
  const { isHotpads, isTrulia, isZillow } = brandUtils;
  const [updateConversationStatusMutation] = useInboxPage_Rh_UpdateConversationStatusMutation();
  const [requestToApply] = useRh_RequestToApplyMutation();
  const [updateConversationStatus] = useConversationNav_Rh_UpdateConversationStatusMutation();

  const useConversationNavRhGetConversationByIdDocumentQuery = useCallback(
    ({ conversationId }: { conversationId: string | undefined }) => {
      const { data, loading, error } = useConversationNav_Rh_GetConversationByIdQuery({
        variables: {
          conversationId: conversationId || '',
        },
        fetchPolicy: 'cache-first',
        skip: !conversationId,
      });
      return { data, loading, error };
    },
    [],
  );

  const useRHGetSyndicationUrlsQuery = useCallback(
    ({ listingAlias, brand }: { listingAlias: string | undefined; brand: Brand }) => {
      const { data, loading, error } = useRh_GetSyndicationUrlsQuery({
        variables: {
          listingAlias: listingAlias!,
          fetchZillow: isZillow(brand),
          fetchHotpads: isHotpads(brand),
          fetchTrulia: isTrulia(brand),
        },
        skip: !listingAlias,
      });
      return { data, loading, error };
    },
    [],
  );

  return {
    updateConversationStatusMutation,
    useConversationNavRhGetConversationByIdDocumentQuery,
    requestToApply,
    updateConversationStatus,
    useRHGetSyndicationUrlsQuery,
  };
};

// prettier-ignore
export const REQUEST_TO_APPLY = gql`
    mutation RH_RequestToApply(
        $alias: String
        $email: String
        $name: String
        $requestToApply: Boolean
        $text: String
    ) {
        RH_RequestToApply(
            alias: $alias
            email: $email
            name: $name
            requestToApply: $requestToApply
            text: $text
        ) {
            status
            success
        }
    }
`;

// prettier-ignore
export const GET_SYNDICATION_URLS = gql`
    query RH_getSyndicationUrls(
        $listingAlias: String!
        $fetchZillow: Boolean!
        $fetchHotpads: Boolean!
        $fetchTrulia: Boolean!
    ) {
        RH_getSyndicationUrls(listingAlias: $listingAlias) {
            hotpadsUrl @include(if: $fetchHotpads)
            zillowUrl @include(if: $fetchZillow)
            truliaUrl @include(if: $fetchTrulia)
        }
    }
`;
